import { desktopBlur, type CardDirection, type FlowThemeCardMotion } from '../../cardMotion';

/** A warp jump: the last card flies past the camera as the next one arrives from the distance. */
export const cosmosCardMotion = (isMobile: boolean): FlowThemeCardMotion => ({
  variants: {
    enter: (direction: CardDirection) => ({ opacity: 0, scale: direction > 0 ? 0.82 : 1.16, filter: desktopBlur(isMobile, 10) }),
    center: { opacity: 1, scale: 1, filter: isMobile ? undefined : 'blur(0px)' },
    exit: (direction: CardDirection) => ({ opacity: 0, scale: direction > 0 ? 1.18 : 0.84, filter: desktopBlur(isMobile, 12) }),
  },
  transition: { duration: 0.8, ease: [0.65, 0, 0.35, 1] },
});
